<template>
  <section>
    <div class="table-responsive">
      <table
        class="table p-0 m-0 dataTable no-footer min-h-[150px] text-nowrap"
      >
        <thead class="bg-white">
          <tr class="py-[5px]">
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Distributor Name
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Distributor Code
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Mapped Status
            </th>
            <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
              Mapped Users
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-if="loading">
            <td colspan="12" class="text-center">
              <div
                class="text-center"
                style="padding-top: 100px; padding-bottom: 50px"
              >
                <span
                  class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                  style="font-size: 8rem"
                ></span>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  Please wait while we load your distributor's list
                </h3>
              </div>
            </td>
          </tr>

          <tr v-for="m in distributors" :key="m.id" v-else>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ m.distributorName }}
            </td>
            <td
              class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
            >
              {{ m.distributorCode }}
            </td>
            <td
              class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
            >
              {{ m.salesUserMappings.length > 0 ? "Mapped" : "Not Mapped" }}
            </td>
            <td>
              <div v-if="m.salesUserMappings.length > 0">
                <ul class="list-disc">
                  <li
                    v-for="userMapping in m.salesUserMappings"
                    :key="userMapping.id"
                  >
                    {{ userMapping.salesUser.otherNames }}
                    {{ userMapping.salesUser.lastName }}
                  </li>
                </ul>
              </div>
              <span v-else>***</span>
            </td>
          </tr>

          <tr v-if="!distributors.length && !loading">
            <td colspan="12">
              <div class="text-center" style="padding-top: 50px">
                <span
                  style="font-size: 4.615rem"
                  class="fa-solid fa-truck text-[#2463EB]"
                ></span>
              </div>
              <h3
                class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                style="padding-bottom: 100px"
              >
                You don't have any distributors.
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        :limit="pageSize"
        :count="pageCount"
        :page="page"
        :itemsCount="count"
        @changePage="gotoPage"
        @changeLimit="changeLimit"
      />
    </div>
  </section>
</template>

<script>
import Pagination from "../Pagination.vue";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      distributors: [],
      loading: true,
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
    };
  },
  created() {
    this.getMappings();
  },
  methods: {
    async getMappings() {
      this.loading = true;
      this.distributors = [];
      this.isBusy = true;
      this.loadingMerchants = true;
      await this.$http
        .get(
          "/Users/getAllMappedAndUnmappedDistributors?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize
        )
        .then(function(res) {
          this.distributors = res.body.data;
          this.page = res.body.pageNumber;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
      this.loadingMerchants = false;
    },
    prev() {
      this.page -= 1;
      this.getMappings();
    },

    next() {
      this.page += 1;
      this.getMappings();
    },

    gotoPage(page) {
      this.page = page;
      this.getMappings();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getMappings();
    },
  },
};
</script>

<style></style>
